import { getAiPortLabel, getCurrentDevice } from 'scratch-vm/src/util/ai-port-map';
import { isWoofkitEnabled } from 'scratch-vm/src/util/device-version';

import PcAiV1Image from './pcAiV1/pcai@3x.png';
// import PcAiV1InsetIconURL from './pcAiV1/pcai.png';

import PcAiV2Image from './pcAiV2/pcai@3x.png';
// import PcAiV2InsetIconURL from './pcAiV2/pcai.png';

import WoofkitImage from './woofkit/woofkit@3x.png';

const device = getCurrentDevice();
const type = typeof window === 'undefined' || !window.location ?
    null :
    new URLSearchParams(window.location.search).get('type');

const extensions = [
    {
        name: 'AI-1 v1',
        extensionId: 'pcAiV1',
        iconURL: PcAiV1Image,
        // insetIconURL: PcAiV1InsetIconURL,
        description: getAiPortLabel(device, 'pcAiV1'),
        featured: true,
        disabled: true,
        internetConnectionRequired: false,
        bluetoothRequired: false,
    },
    {
        name: 'AI-1 v2',
        extensionId: 'pcAiV2',
        iconURL: PcAiV2Image,
        // insetIconURL: PcAiV2InsetIconURL,
        description: getAiPortLabel(device, 'pcAiV2'),
        featured: true,
        disabled: true,
        internetConnectionRequired: false,
        bluetoothRequired: false,
    },
];

if (isWoofkitEnabled(device, type)) {
    extensions.push({
        name: 'Woofkit',
        extensionId: 'woofkit',
        iconURL: WoofkitImage,
        description: 'Emotions and actions for the Woofkit robot dog',
        featured: true,
        disabled: false,
        internetConnectionRequired: false,
        bluetoothRequired: false,
    });
}

export default extensions;
